// Gallery views must stay separate from the administrator during impersonation.
export const getViewStorage = () =>
  sessionStorage.getItem("SB_IMPERSONATION_ACTIVE") === "1" ? sessionStorage : localStorage;
